import { MutationCache, QueryClient } from "@tanstack/react-query";

// A 4xx answer is deterministic: repeating the same request cannot succeed.
const NON_RETRYABLE_CODES = new Set(["BAD_REQUEST", "UNAUTHORIZED", "FORBIDDEN", "NOT_FOUND"]);
const DEFAULT_RETRIES = 3;
function retryQuery(failureCount, error) {
  const code = error?.data?.code;
  if (typeof code === "string" && NON_RETRYABLE_CODES.has(code)) return false;
  return failureCount < DEFAULT_RETRIES;
}
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: retryQuery
    }
  },
  mutationCache: new MutationCache({
    onSuccess: () => {
      queryClient.invalidateQueries();
    }
  })
});